import styled from 'styled-components';
import { Stack } from '@carbon/react';

export const StyledStack = styled(Stack)`
  width: min-content;
`;
